import * as React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { ptBR } from '@mui/x-date-pickers/locales';
import 'dayjs/locale/pt-br';
import { CalendarType } from './types/types';

const CalendarMui = (props: CalendarType) => (
  <LocalizationProvider
    dateAdapter={AdapterDayjs}
    localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
    adapterLocale="pt-br"
  >
    <DatePicker {...props} />
  </LocalizationProvider>
);

export default CalendarMui;
